// extracted by mini-css-extract-plugin
module.exports = {"forgotLink":"login_forgotLink__vc6yL","loadingIndicator":"login_loadingIndicator__79S1k"};